import * as types from 'misc/types';
import * as actions from 'misc/actions';

const envelope_contents = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_ENVELOPE_CONTENTS_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_ENVELOPE_CONTENTS_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_ENVELOPE_CONTENTS_GET.FAILURE:
            return actions.error(state, action.error);

        default:
            return state;
    }
};

export default envelope_contents;



// WEBPACK FOOTER //
// ./src/reducers/envelope_contents.js